export const foreignCountriesListAdapter = (data) => {
  const list = []
  data
    .find((el) => el.name === 'Форма иностранцы')
    .propertyValuesRelation.filter(
      (item) => item.targetElement.propertyValues.length
    )
    .map((property) => {
      const countryValue = property.targetElement.propertyValues.find(
        (propertyValue) => propertyValue.property.code === 'countryName'
      ).value
      list.push({
        name: countryValue,
        value: countryValue,
      })
    })
  return list
}
